const US = [
    'firstName',
    'lastName',
    'phone',
    'email',
    'zip'
]

const FR = [
    'firstName',
    'lastName',
    'phone',
    'email',
    'zip'
]

const CN = [
    'firstName',
    'lastName',
    'phone',
    'email',
    'province',
    'cities'
]

const MO = [
    'firstName',
    'lastName',
    'phone',
    'email'
]

const HK = [
    'firstName',
    'lastName',
    'phone',
    'email'
]

const AE = [
    'firstName',
    'lastName',
    'phone',
    'email'
]

const KR = [
    'firstName',
    'lastName',
    'phone',
    'email',
    'province',
    'cities',
    'localName'
]

export default function Validation() {
    return {
        US,
        FR,
        CN,
        MO,
        HK,
        AE,
        KR
    }
}